import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { I18N_NAMESPACES } from "../../../helpers/constants";
import {
  AddButtonVariant,
  RewardCardImg,
  Container,
  RewardCard,
  RewardCardImgWrapper,
  RewardCardFooter,
  AddButtonWrapper,
  AddButton,
  ButtonTextWrapper,
  Points,
} from "./style";

export interface MerchCardProps {
  name: string;
  linkUrl: string;
  pointsCost: number | null;
  image: string;
  unlockLevel?: number | null;
  onAddButtonClick: (event: React.MouseEvent<HTMLElement>) => void;
  hasStock: boolean;
  onMerchCardClick: (event: React.MouseEvent<HTMLElement>) => void;
  addButtonText: string;
  addButtonVariant: AddButtonVariant;
}

const MerchCard = ({
  name,
  linkUrl,
  pointsCost,
  image,
  onAddButtonClick,
  hasStock,
  onMerchCardClick,
  addButtonText,
  addButtonVariant,
}: MerchCardProps) => {
  const { t } = useTranslation([I18N_NAMESPACES.COMMON]);

  const RewardImage = (): ReactElement => (
    <RewardCardImgWrapper to={linkUrl} onClick={(event) => onMerchCardClick(event)}>
      <RewardCardImg
        // TODO: Add placeholder image.
        src={image ?? ""}
        alt={name ?? ""}
      />
    </RewardCardImgWrapper>
  );

  const AddRewardButton = (): ReactElement => (
    <AddButtonWrapper>
      <AddButton variant={addButtonVariant} disabled={!hasStock} onClick={(event) => onAddButtonClick(event)}>
        <ButtonTextWrapper>
          {addButtonText}
          <Points>{t("myDashboard:pointsAbbr", { points: pointsCost })}</Points>
        </ButtonTextWrapper>
      </AddButton>
    </AddButtonWrapper>
  );

  const RewardFooter = (): ReactElement => (
    <RewardCardFooter>
      <AddRewardButton />
    </RewardCardFooter>
  );

  return (
    <Container>
      <RewardCard>
        <RewardImage />
        <RewardFooter />
      </RewardCard>
    </Container>
  );
};

export default MerchCard;
